<!-- mettal-3\src\components\Writing.vue -->
<template>
  <div :class="[`writing`, className || ``]">
    <img
      class="vector-148"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-585.svg"
      alt="Vector"
    />
    <img
      class="vector-149"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-586.svg"
      alt="Vector"
    />
    <img
      class="vector-150"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-587.svg"
      alt="Vector"
    />
    <img
      class="vector-151"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-588.svg"
      alt="Vector"
    />
    <img
      class="vector-152"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-589.svg"
      alt="Vector"
    />
  </div>
</template>

<script>
export default {
  name: "Writing",
  props: ["className"],
};
</script>

<style>
.writing {
  aspect-ratio: 1;
  height: 83.34%;
  left: 0;
  position: absolute;
  top: 6.67%;
  width: 14.62%;
}

.vector-148 {
  height: 99.99%;
  left: 75%;
  position: absolute;
  top: 0;
  width: 25%;
}

.vector-149 {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 66.67%;
}

.vector-150 {
  height: 8.33%;
  left: 12.5%;
  position: absolute;
  top: 41.67%;
  width: 37.5%;
}

.vector-151 {
  height: 8.33%;
  left: 12.5%;
  position: absolute;
  top: 58.34%;
  width: 37.5%;
}

.vector-152 {
  height: 8.33%;
  left: 12.5%;
  position: absolute;
  top: 75%;
  width: 37.5%;
}

.writing.writing-4 {
  width: 14.12%;
}
</style>
